const $inject = ['$http', 'userProfileService', 'apiService'];

const userInviteService = ($http, userProfileService, apiService) => {
  const service = {
    getInvites,
    sendInvite,
    completeInvite,
    generateMessage,
    resendInvite,
    deleteInvite,
    invites: []
  };

  function getInvites() {
    const debtorId = userProfileService.profile.DebtorIdentifier;
    const apiUrl = apiService.getUrl('userInvite', { debtorId });

    return $http.get(apiUrl)
      .then((res) => {
        let data = res.data;
        service.invites = data;
      })
      .catch(() => {

      });
  }

  function completeInvite(profile, debtorId, token) {
    const apiUrl = apiService.getUrl('completeInvite', { debtorId, token });
    return $http.post(apiUrl, profile, { isPublic: true });
  }

  function sendInvite(invite) {
    const debtorId = userProfileService.profile.DebtorIdentifier;
    const apiUrl = apiService.getUrl('userInvite', { debtorId });
    return $http.post(apiUrl, invite);
  }

  function generateMessage(userProfile) {
    return `Hi there,
I've set us up on SMART Corporate Travel so we can easily book and manage all of our business travel.

Click the link below to get started.

Regards,
${userProfile.Firstname}`;
  }

  function resendInvite(id) {
    const debtorId = userProfileService.profile.DebtorIdentifier;
    const apiUrl = apiService.getUrl('userInvite', { debtorId });
    return $http.put(apiUrl + '/' + id)
  }

  function deleteInvite(id) {
    const debtorId = userProfileService.profile.DebtorIdentifier;
    const apiUrl = apiService.getUrl('userInvite', { debtorId });
    return $http.delete(apiUrl + '/' + id);
  }

  return service;
};

userInviteService.$inject = $inject;

export default userInviteService;


// WEBPACK FOOTER //
// ./src/services/userInviteService.js